import { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { FeatureFlagsPage } from '@/app/support/pages/feature-flags-page'
import { getAuth } from '@/lib/auth'
import { SignInPage } from '@/pages/sign-in-page'

export function App() {
  const [signedIn, setSignedIn] = useState(() => getAuth() !== null)
  if (!signedIn) {
    return <SignInPage onSignedIn={() => setSignedIn(true)} />
  }
  return (
    <Routes>
      <Route path="/ff/:key?" element={<FeatureFlagsPage />} />
      <Route path="*" element={<Navigate to="/ff" replace />} />
    </Routes>
  )
}
